import moment from "moment-timezone";
import { formatData, sortInstaPages } from "../actions/insightsActionUtils";
import {
    FETCH_TIKTOK_PAGE_LIST,
    FETCH_TK_METRICS,
    FETCH_TK_PAGE_FOLLOWERS,
    SET_TIKTOK_SELECTED_PAGE,
    UPDATE_TIKTOK_DURATION_FILTER,
} from "../actions/tiktokInsightsActions";
import { formatTiktokData } from "../actions/tiktokInsightsActionUtils";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    pagesListLoading: false,
    pagesList: [],
    chartData: {},
    chartDataLoading: {},
    chartLoadingFailed: {},
    selectedTiktokPage: [],
    durationFilter: {
        duration: "7",
        startDateTime: moment(new Date()).subtract(6, "days").startOf("day").format("YYYY-MM-DD"),
        endDateTime: moment(new Date()).format("YYYY-MM-DD"),
    },
    pageInfo: 0,
    followerChartLoading: false,
};

const tiktokInsightsReducers = (state = initialState, action) => {
    switch (action.type) {
        case isPending(FETCH_TIKTOK_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: true,
            });

        case isRejected(FETCH_TIKTOK_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: false,
            });

        case isFulfilled(FETCH_TIKTOK_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: false,
                pagesList: sortInstaPages(action.payload) || [],
            });

        case SET_TIKTOK_SELECTED_PAGE:
            return (state = {
                ...state,
                selectedTiktokPage: action.payload,
            });

        case UPDATE_TIKTOK_DURATION_FILTER:
            return (state = {
                ...state,
                durationFilter: { ...state.filterDuration, ...action.payload },
            });

        case isPending(FETCH_TK_METRICS):
            return (state = {
                ...state,
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: true },
            });

        case isFulfilled(FETCH_TK_METRICS):
            return (state = {
                ...state,
                chartData: { ...state.chartData, [action.payload.chart_name]: formatTiktokData(action.payload) },
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: false },
            });

        case isRejected(FETCH_TK_METRICS):
            return (state = {
                ...state,
                chartLoadingFailed: { ...state.chartLoadingFailed, [action.payload.chart_name]: true },
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: false },
            });

        case isPending(FETCH_TK_PAGE_FOLLOWERS):
            return (state = {
                ...state,
                followerChartLoading: true,
            });

        case isFulfilled(FETCH_TK_PAGE_FOLLOWERS):
            return (state = {
                ...state,
                followerChartLoading: false,
                pageInfo: action.payload || { followers_count: 0 },
            });

        default:
            return state;
    }
};

export default tiktokInsightsReducers;
